var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.content,"placement":"top"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }